import React, { useEffect, useRef } from "react";
import { showToast } from "../../util/toastHelper";
import { apiEndpoints } from "../../util/constant";
import { useParams } from "react-router";
import { CallWithAuth } from "../../action/apiActions";
import { LoaderIndex } from "../Loader/LoaderIndex";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { GET_PROMPTS, PATIENT_ASSESSMWNT_RECOMMENDED } from "../../action/apiPath";
import mic from '../../assets/img/mute-mic.svg';
import mutemic from '../../assets/img/unmute-mic.svg';
import SpeechRecognition, { useSpeechRecognition } from "react-speech-recognition";

const MySwal = withReactContent(Swal);

const PromptEditor = ({
  field,
  promptValue,
  onChange,
  onTest,
  onUpdate,
  onReset,
  onCancel,
  cancelValue,
  promptResult,
  id: propId, // optional prop
  isMiceActive,
  onMicChange
}) => {
  const textareaRef = useRef(null);
  const { id: paramId } = useParams();
  // const { id } = useParams();
  const id = propId ?? paramId; // Use prop first, fallback to URL param

  const [isLoading, setIsLoading] = React.useState(false);
  const [isUpdated, setIsUpdated] = React.useState(false);
  const [isReset, setIsReset] = React.useState(false);

  const promptResultData = promptResult?.find(
    (endpoint) => endpoint.apiEndpointName == field
  );

  const streamCallWithAuth = async (url, body) => {
    const token = localStorage.getItem('accessToken'); // Or however you get your auth token
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(body),
    });
  };

  const handleClick = async () => {
    if (!promptValue) {
      showToast("error", "Please enter a prompt before testing.");
      return;
    }

    let specificPromptEndpoint = apiEndpoints.find(
      (endpoint) => endpoint.key == field
    );
    
    if (specificPromptEndpoint === undefined) {
      showToast("error", "No endpoint found for the selected prompt.");
      return;
    }
    
    if (specificPromptEndpoint.stream) {
      setIsLoading(true);

      const response = await streamCallWithAuth(`${specificPromptEndpoint.endPoint}${id}`, { 
        prompt_text: promptValue
      });

      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let accumulatedText = "";

      // 2. Read the stream
      while (true) {
        const { value, done } = await reader.read();

        const chunk = decoder.decode(value, { stream: true });

        let resp = null;
        try {
          resp = JSON.parse(chunk);
        } catch (e) {}

        if (resp?.error) {
          showToast("error", resp?.message);
        }

        if (done) {
          break;
        }
        
        // 3. Parse SSE format (data: {"chunk": "..."})
        const lines = chunk.split("\n\n");
        lines.forEach(line => {
          if (line.startsWith("data: ")) {
            try {
              const data = JSON.parse(line.replace("data: ", ""));
              
              if (data.chunk) {
                accumulatedText += data.chunk.replaceAll("data: ", "").replaceAll("\n\ndata: ", "").replace(/\n\n$/, '');
                
                // 4. Update state in real-time
                onTest(accumulatedText, field);
              }
              
              if (data.status === 'done') {
                
              }
            } catch (e) {
              showToast("error", "Report Not Generated");
              console.error("Error parsing stream chunk", e);
            }
          }
        });
      }

      setIsLoading(false);

    } else {
      try {    
        setIsLoading(true);
  
        const response = await CallWithAuth(
          "POST",
          `${specificPromptEndpoint.endPoint}${id}`,
          { prompt_text: promptValue }
        );
  
        if (response.res.data.statusCode === 200) {
          onTest(response.res.data?.data[field], field);
        } else {
          
        }
      } catch (error) {
        showToast("error", "An error occurred while testing the prompt.");
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleUpdate = async () => {
    const result = await MySwal.fire({
      title:
        "Are you sure you want to upadate this prompt.",
      text: "",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Update!",
    });
    if (result.isConfirmed) {
      if (!promptValue) {
        showToast("error", "Please enter a prompt before testing.");
        return;
      }

      let specificPromptEndpoint = promptResult.find(
        (endpoint) => endpoint.apiEndpointName == field
      );

      let specificPromptEndpointUrl = apiEndpoints.find(
        (endpoint) => endpoint.key == field
      );
      
      if (specificPromptEndpoint === undefined) {
        showToast("error", "No endpoint found for the selected prompt.");
        return;
      }
      
      if (specificPromptEndpointUrl.stream) {
        setIsLoading(true);

        const response = await streamCallWithAuth(`${specificPromptEndpointUrl.endPoint}${id}`, { 
          prompt_text: promptValue,
          is_updated: true
        });
  
        const reader = response.body.getReader();
        const decoder = new TextDecoder();
        let accumulatedText = "";
        let error = null;
  
        // 2. Read the stream
        while (true) {
          const { value, done } = await reader.read();
  
          const chunk = decoder.decode(value, { stream: true });
  
          let resp = null;
          try {
            resp = JSON.parse(chunk);
          } catch (e) {}
  
          if (resp?.error) {
            error = resp?.message;
            showToast("error", resp?.message);
          }
  
          if (done) {
            onUpdate(accumulatedText, field, promptValue, !error ? true : false);
            break;
          }
          
          // 3. Parse SSE format (data: {"chunk": "..."})
          const lines = chunk.split("\n\n");
          lines.forEach(line => {
            if (line.startsWith("data: ")) {
              try {
                const data = JSON.parse(line.replace("data: ", ""));
                
                if (data.chunk) {
                  accumulatedText += data.chunk.replaceAll("data: ", "").replaceAll("\n\ndata: ", "").replace(/\n\n$/, '');
                  
                  // 4. Update state in real-time
                  onUpdate(accumulatedText, field, promptValue, false);
                }
                
                if (data.status === 'done') {
                  
                }
              } catch (e) {
                showToast("error", "Report Not Generated");
                console.error("Error parsing stream chunk", e);
              }
            }
          });
        }
  
        setIsLoading(false);

      } else {
        try {
          setIsUpdated(true);
          const response = await CallWithAuth(
            "POST",
            `${field == 'recommendation' ? PATIENT_ASSESSMWNT_RECOMMENDED : specificPromptEndpointUrl.endPoint}${id}`,
            {
              prompt_text: promptValue,
              is_updated: true
            },
          );
          if (response.res.data.statusCode === 200) {
            onUpdate(response.res.data?.data[field == 'recommendation' ? 'recommendations' : field], field, promptValue);
          } else {
  
          }
        } catch (error) {
          showToast("error", "An error occurred while testing the prompt.");
        } finally {
          setIsUpdated(false);
        }
      }
    }
  }
  const handleReset = async () => {
    const result = await MySwal.fire({
      title: "Are you sure you want to reset this prompt?",
      text: "",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Reset prompt!",
    });
    if (result.isConfirmed) {
      if (!promptValue) {
        showToast("error", "Please enter a prompt before testing.");
        return;
      }

      let specificPromptEndpoint = promptResult?.find(
        (endpoint) => endpoint.apiEndpointName == field
      );

      if (specificPromptEndpoint === undefined) {
        showToast("error", "No endpoint found for the selected prompt.");
        return;
      }
      try {      
        setIsReset(true);
        const response = await CallWithAuth(
          "PATCH",
          `${GET_PROMPTS}/${specificPromptEndpoint?.id}`,
          { apiEndpointName: specificPromptEndpoint?.apiEndpointName },
        );
        if (response.res.data.statusCode === 200) {
          onReset(field, response.res.data?.data);
        } else {

        }
      } catch (error) {
        showToast("error", "An error occurred while testing the prompt.");
      } finally {
        setIsReset(false);
      }
    }
  }

  const { transcript, listening, resetTranscript, browserSupportsSpeechRecognition } =
    useSpeechRecognition();
  const finalTranscriptRef = useRef('');

  if (!browserSupportsSpeechRecognition) {
    alert('Your browser does not support speech recognition.');
  }
  const previousTranscriptRef = useRef('');
  const debounceTimer = useRef(null);
  // 👂 Track only new spoken text
  useEffect(() => {
    if (!isMiceActive) return;
    // Clear any pending update
    if (debounceTimer.current) clearTimeout(debounceTimer.current);
    // Set a delay before appending to formData
    debounceTimer.current = setTimeout(() => {
      const prev = previousTranscriptRef.current;
      const delta = transcript.slice(prev.length);
      if (delta.trim()) {
        onChange(field, promptValue + ' ' + delta.trim())
        previousTranscriptRef.current = transcript;
      }
    }, 1000); // wait 1 second for the phrase to settle
  }, [transcript, isMiceActive]);

  const checkMicPermission = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      // Mic granted, you can stop the stream immediately
      stream.getTracks().forEach(track => track.stop());
      console.log('✅ Microphone access granted');
      return true;
    } catch (err) {
      if (err.name === 'NotAllowedError') {
        alert('Microphone access denied. Please enable it in your browser settings.');
      } else if (err.name === 'NotFoundError') {
        alert('No microphone found on this device.');
      } else {
        alert('Failed to access microphone.');
      }
      console.warn('Mic access error:', err);
      return false;
    }
  };

  const handleVoiceInput = async () => {
    if (isMiceActive) {
      onMicChange(null);
      return;
    }

    let micPermission = await checkMicPermission();
    console.log('micPermission', micPermission);

    if (!micPermission) {
      return;
    }

    onMicChange(field);
  };

  useEffect(() => {
    if (!isMiceActive) {
      SpeechRecognition.stopListening();
      resetTranscript();
      previousTranscriptRef.current = '';
    } else {
      SpeechRecognition.stopListening();
      resetTranscript();
      previousTranscriptRef.current = '';

      setTimeout(() => {
        SpeechRecognition.startListening({ continuous: true, language: 'en-US' });
      }, 200);
    }
  }, [isMiceActive]);

  return (
    <>
      <div className="mt-3 relative">
        <textarea
          ref={textareaRef}
          className="form-control pr"
          rows={4}
          value={promptValue ? (promptValue || "").replace(/\\n/g, "\n") : ""}

          onChange={(e) => onChange(field, e.target.value)}
          placeholder="Edit your prompt here..."
        />
        <button
          type="button"
          onClick={() => handleVoiceInput()}
          className="microphone"
        >
          {isMiceActive ? (
            <img
              src={mutemic}
              alt="microphone"
              width="36"
              height="36"
            />
          ) : (
            <img
              src={mic}
              alt="microphone"
              width="24"
              height="24"
            />
          )}
        </button>
      </div>

      <div className="mt-2 d-flex gap-2">
        <button
          className="btn btn-primary"
          disabled={isReset || isUpdated || isLoading}
          onClick={() => handleClick()}
        >
          Test Prompt{" "}
          {isLoading && (
            <>
              {""}
              <LoaderIndex />
            </>
          )}
        </button>
        <button
          className="btn btn-primary"
          // onClick={() => onUpdate(field)}
          onClick={() => handleUpdate()}
          disabled={isReset || isUpdated || isLoading}

        >
          Update Prompt  {isUpdated && (
            <>
              {""}
              <LoaderIndex />
            </>
          )}
        </button>
        {promptResultData?.ownedBy && (
          <button
            className="btn btn-primary"
            // onClick={() => onCancel(field, cancelValue)}
            onClick={() => handleReset()}
            disabled={isReset || isUpdated || isLoading}
          >
            Reset Prompts{isReset && (
              <>
                {""}
                <LoaderIndex />
              </>
            )}
          </button>
        )}
        <button
          className="btn btn-primary"
          onClick={() => {
            SpeechRecognition.stopListening();
            resetTranscript();
            previousTranscriptRef.current = '';
            if (isMiceActive) onMicChange(null);
            onCancel(field, cancelValue)
          }}
          disabled={isLoading || isUpdated}
        >
          Cancel Prompts
        </button>
      </div>
    </>
  );
};

export default PromptEditor;
